module.exports = __webpack_public_path__ + "static/media/4-item-e.4ac97b55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/4-item-e.jpg
// module id = 1171
// module chunks = 33